import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../Button/Button';

class RowActionButton extends React.Component {
  handleClick = () => this.props.handleClick(this.props.original);

  render() {
    const { children, ...other } = this.props;
    return (
      <Button
        onClick={this.handleClick}
        style={{ margin: '-5px -15px', padding: '5px 15px' }}
        {...other}
      >
        {children}
      </Button>
    );
  }
}
RowActionButton.propTypes = {
  original: PropTypes.objectOf(PropTypes.any).isRequired,
  handleClick: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default RowActionButton;
